export const CRM_POST = "CRM_POST";
export const CRM_RESET = "CRM_RESET";
export const com_CRM_POST = "com_CRM_POST";
export const com_CRM_RESET = "com_CRM_RESET";
